import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {Dashboard} from './iface'
import {VendorMinInf} from '../../shared/interfaces/common'
import {VendorSearch} from '../../shared/interfaces/vendor-details'
import {environment} from '../../../environments/environment'
import {Vendors} from '../vendor.items/list/list.service'
import {IdbCache} from '../../shared/services/cache.etc/idb.cache'
import {Account} from '../accounts/accounts.iface'

export interface AccountKV {
  [key: string]: Account
}

@Injectable()
export class DashboardService {
  constructor(
    private http: HttpClient,
    private IDBC: IdbCache
  ) {
  }

  /**
   * Отримує дані вендора згідно інтерфейсу VendorSearch
   * для подальшого відправлення в сервіс MlVsService
   * @param vendor - VendorMinInf
   */
  getVendorDataToSelect(vendor: VendorMinInf): Promise<VendorSearch> {
    return new Promise<VendorSearch>((resolve, reject) => {
      const category = environment.categoryDec2Str(vendor.category).api
      const url = environment.apiPrefix + `vendor/${vendor.vendorId}/${category}`
      this.http.get<VendorSearch>(url).subscribe((data) => {
        console.log('got VS data: ', data)
        resolve(data)
      }, error => {
        console.log('error got data ', error)
        reject(error)
      })
    })
  }

  /**
   * Get data for Company
   * @param $company -
   */
  getAnalyticDataForCompany($company: string): Promise<Dashboard> {
    return new Promise<Dashboard>((resolve, reject) => {
      this.http.get<Dashboard>(`${environment.apiPrefix}dashboard/?company=${$company}`)
        .subscribe((data) =>  {
          console.log('got data: ', data)
          resolve(data)
        }, error => {
          console.log('Error: ', error)
          reject(error)
        })
    })
  }

  getAllAdmins(): Promise<AccountKV> {
    return new Promise<AccountKV>((resolve, reject) => {
      this.http.get<{results: Account[]}>(`${environment.apiV1}admin/all`)
        .subscribe((data) =>  {
          // console.log('got data: ', data)
          const acc = [] as unknown as AccountKV
          data.results.forEach(account => {
            // acc[account.adminId] = account.administrator
            acc[account.adminId] = account
          })
          resolve(acc)
        }, error => {
          console.log('Error: ', error)
          reject(error)
        })
    })
  }

  /**
   * Get all Vendor-item for ADMIN
   */
  getAllVendors(): Promise<Vendors[]> {
    return new Promise<Vendors[]>((resolve, reject) => {
      this.IDBC.getVendorForms().then(resolve, reject)
      // this.http.get(`${environment.apiPrefix}/vendor/form`)
      //   .subscribe((res: { results: Vendors[] }) => {
      //     resolve(res.results)
      //   }, e => {
      //     reject(e)
      //   })
    })
  }
}
